import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { Analytics } from '@vercel/analytics/react';
import { parseCookies } from 'nookies'
import NProgress from 'nprogress'
import { appWithTranslation } from 'next-i18next'

import { appConfigContext } from 'nexchange-service/appServiceConfig'
import {
    setHeadersFromStore,
    storeReferralTokenFromQuery,
    setRefreshToken, getReferralToken, getAuthToken,
} from 'nexchange-service/module/auth'

// Only in _app.tsx css files can be imported
import '@/src/styles/main.scss'
import 'nprogress/nprogress.css'
import 'react-tabs/style/react-tabs.css'
import 'react-phone-input-2/lib/style.css'

import config from '@/src/config'

declare global {
    interface Window {
        dataLayer: Record<string, any>[]
    }
}

function NexchangeApp({ Component, pageProps, cookies, query }) {
    const { events } = useRouter()
    const authToken = getAuthToken();
    const referralToken = getReferralToken()

    useEffect(() => {
        const NProgressStart = () => NProgress.start()
        const NProgressStop = () => NProgress.done()

        events.on('routeChangeStart', NProgressStart)
        events.on('routeChangeComplete', NProgressStop)
        events.on('routeChangeError', NProgressStop)

        return () => {
            events.off('routeChangeStart', NProgressStart)
            events.off('routeChangeComplete', NProgressStop)
            events.off('routeChangeError', NProgressStop)
        }
    }, [])

    useEffect(() => {
        storeReferralTokenFromQuery(query)
    }, [query])

    useEffect(() => {
        setHeadersFromStore()
    }, [referralToken, authToken]);

    useEffect(() => {
        setRefreshToken()
    }, [cookies])

    return (
        <>
            <Component {...pageProps} />
            <Analytics />
        </>
    )
}

NexchangeApp.getInitialProps = async appContext => {
    const isServerSide = typeof window === 'undefined'
    // @ts-ignore
    appConfigContext.setAppConfig(config)

    const { ctx, router } = appContext
    const { query } = router

    const cookies = isServerSide ? ctx.req.cookies : parseCookies(appContext)

    return {
        cookies,
        query,
    }
}

// @ts-ignore
export default appWithTranslation(NexchangeApp)
